import React from 'react';

interface ILoaderIconProps {
	size?: string;
}

export const LoaderIcon = ({ size = '24' }: ILoaderIconProps) => {
	return (
		<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby="loaderIcon">
			<title id="loaderIcon">loader icon</title>
			<circle cx="12" cy="12" r="11" stroke="black" strokeOpacity="0.16" strokeWidth="2" />
			<path
				d="M18.3262 3C16.5369 1.73994 14.3549 1 12 1C8.35654 1 5.12677 2.77142 3.125 5.5"
				stroke="#3D3D3D"
				strokeWidth="2"
			/>
		</svg>
	);
};
